

<template>
  <div style="position: fixed; top:0; left:0; width: 100%; height: 100%; overflow-y: auto;">
    <div class="place-restaurant-image" style="height: 600px;">
      <slider animation="fade" style="height:100%">
        <slider-item
          v-for="(img, index) in images"
          :key="index"
          style="z-index: 0; height:100%;"


        >
          <div class="place-restaurant-image"  style="height:100%" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
        </slider-item>
      </slider>



      <div class="place-order-restaurant-title-container level-2">

        <div class="place-order-title-container" id="place-title" style="margin-top: 50px;">
          {{currentMerchantItem.title}}
        </div>
        <!--        <div class="home-main-description" style="width: 100%; text-align: center; color: white; margin-top: 11px;">-->
        <!--          {{currentMerchantItem.webSetting.topMessageSmall}}-->
        <!--        </div>-->
        <div style=" margin-top: 130px; width: 300px; margin-left: auto; margin-right: auto;">

          <div class="home-main-order-btn" @click="moveToTakeaway">
            Click & Collect
          </div>
          <div v-if="partner !== false" class="home-main-order-btn" @click="showDestinationInput = true">
            Deliver to
            <img v-if="partner.webSetting !== null && partner.webSetting.icon !== null" :src="partner.webSetting.icon" style="width: 100%;"/>
            <div v-else>{{partner.title}}</div>
            table

          </div>


        </div>
      </div>





    </div>
    <div style="margin-top: 10px; padding-bottom: 33%; background-size: cover; background-repeat: no-repeat; background-position: center;"
         v-if="currentMerchantItem.webSetting !== undefined && currentMerchantItem.webSetting !== null && currentMerchantItem.webSetting.bannerImage !== null && currentMerchantItem.webSetting.bannerImage.length > 0"
         v-bind:style="{backgroundImage: 'url(' + currentMerchantItem.webSetting.bannerImage + ')'}">

    </div>
    <div style="width: 100%; text-align: center;" v-if="currentMerchantItem.webSetting !== undefined && currentMerchantItem.webSetting !== null">
      <div class="container web-section" style="max-width: 1000px;">
        <div class="row">
          <div class="col-12 text-center webpage-section-header">
            ABOUT US
            <div class="under-bar"></div>
          </div>
          <div class="col-12 webpage-section-content" style="padding-top: 28px;" v-html="currentMerchantItem.webSetting.aboutUs.replace(/\n/g, '<br/>')">


            <!--                <span style="color: #FF5733; font-size: 30px;"><i class="fas fa-quote-left"></i></span><br/>-->

            <!--                <div style="padding-left: 30px;">-->
            <!--                {{}}-->
            <!--                </div>-->
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;">

      <div class="order-place-bottom-container">
        <div class="container web-section">
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="webpage-section-header smaller text-left" >
                Contact Us
              </div>
              <div class="place-bottom-container" style="text-decoration: underline;">
                <a :href="'tel:' + currentMerchantItem.contact">{{currentMerchantItem.contact}}</a>
                <br/>
                <a :href="'http://maps.google.com/?q=' + currentMerchantItem.address" target="_blank" >{{currentMerchantItem.address}}</a>
                <br/>

                <!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
              </div>
              <div class="place-bottom-container" v-if="currentMerchantItem.webSetting !== undefined && currentMerchantItem.webSetting !== null && currentMerchantItem.webSetting.moreContact.length > 0" v-html="currentMerchantItem.webSetting.moreContact">

              </div>
            </div>
            <div class="col-12 col-md-4">
              <!--                <div class="round-box" style="margin:auto;">-->
              <div class="webpage-section-header smaller text-left">
                Opening Hours
              </div>
              <div class="body text-left place-bottom-container custom"
                   v-if="currentMerchantItem.webSetting !== undefined &&
                      currentMerchantItem.webSetting !== null &&
                      currentMerchantItem.webSetting.openingHours !== null &&
                      currentMerchantItem.webSetting.openingHours.length > 0"
                   v-html="currentMerchantItem.webSetting.openingHours.replaceAll('p>', 'div>')">
              </div>
              <!--              <div class="body text-left place-bottom-container">-->
              <!--                <template  v-for="(day, di) in openingTime">-->
              <!--                  <div v-bind:key="'day-opening-hours-'+ di">-->
              <!--                    {{day.dayString}}:-->
              <!--                    <template v-if="day.open==false">-->
              <!--                      Closed-->
              <!--                    </template>-->
              <!--                    <template v-if="day.open == true && day.times != undefined && day.times.length > 0">-->
              <!--                      <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>-->

              <!--                    </template>-->
              <!--                  </div>-->
              <!--                </template>-->

              <!--              </div>-->
            </div>
            <div class="col-12 col-md-4" v-if="currentMerchantItem.webSetting !== undefined && currentMerchantItem.webSetting !== null">
              <div class="webpage-section-header smaller text-left">
                Location
              </div>
              <div style="height: 300px;" id="mapName">
                <iframe :src="currentMerchantItem.webSetting.googleMap" width="100%" height="100%" frameborder="0" style="border:0"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
        <!--        <a :href="'http://maps.google.com/?q=' + currentMerchantItem.address" target="_blank" >{{currentMerchantItem.address}}</a>-->
        <!--        <a :href="'tel:' + currentMerchantItem.contact">{{currentMerchantItem.contact}}</a>-->
        <!--        <table style="width: 100%; display: none;">-->
        <!--          <tr>-->
        <!--            <td style="width: 25px; vertical-align: top;">-->
        <!--              <span><img class="info-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-marker.png"/></span>-->
        <!--            </td>-->
        <!--            <td>-->
        <!--              <a :href="'http://maps.google.com/?q=' + currentMerchantItem.address" target="_blank" >{{currentMerchantItem.address}}</a>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td style="width: 30px;">-->
        <!--              <span><img class="info-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-phone.png"/></span>-->
        <!--            </td>-->
        <!--            <td>-->
        <!--              <a :href="'tel:' + currentMerchantItem.contact">{{currentMerchantItem.contact}}</a>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr style="display: none;">-->
        <!--            <td style="width: 30px;">-->
        <!--              <span><img class="info-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-clock.png"/></span>-->
        <!--            </td>-->
        <!--            <td>-->
        <!--              Today <span v-if="isShopOpen==false">Closed</span><template v-else><span v-if="shopSlots.length > 0" v-for="(slot, si) in shopSlots"><span v-if="si > 0"> ,</span>{{slot.fromString}}~{{slot.toString}}</span><span v-else>Closed</span></template>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </table>-->



      </div>
      <div v-if="showDestinationInput === true" style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); z-index: 2;">
        <div style="position: absolute; width: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; border-radius: 10px; padding-top: 10px; padding-bottom: 30px;">
          <div class="container input-form-container">
            <div class="row">
              <div class="col-12" style="padding-bottom: 30px;">
                <img v-if="currentMerchantItem.webSetting !== null && currentMerchantItem.webSetting.icon !== null" :src="currentMerchantItem.webSetting.icon" style="max-height: 80px;"/>
              </div>
              <div class="col-12">
                <img v-if="partner.webSetting !== null && partner.webSetting.icon !== null" :src="partner.webSetting.icon" style="max-width: 80%;"/>
              </div>
              <div class="col-12" style="padding-top: 18px;">
                Please enter your <span v-if="partner !== false">table number</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input v-model="destination" class="form-control" style="text-align: center; font-size: 50px;" />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="white-gray-btn" @click="showDestinationInput = false; destination = ''">Close</div>
              </div>
              <div class="col-6">
                <div class="black-btn" @click="moveToDelivery">Start order</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog/>
  </div>
</template>
<script>

import { Slider, SliderItem } from "vue-easy-slider";
import EventBus from "../api/event-bus";
import { getMerchantPermalink, submitLog } from "../api/borium";
import Router from "../router";

export default {
  name:'CollabOrder',
  data() {
    return {
      images:[],
      currentMerchantItem:false,
      isShopOpen: false,
      shopSlots:[],
      showDestinationInput: false,
      destination:'',
      partner: false,
    }
  },
  components: {
    Slider,
    SliderItem,
  },
  created() {
  },
  mounted() {
    EventBus.$emit("modeChanged", 0);
    this.loadPage();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    loadPage: function() {

      let self = this;
      if(this.$route.params.hasOwnProperty('permalink')) {
        // console.log("PL: " + this.$route.params.permalink);



        getMerchantPermalink(this.$route.params.permalink)
          .then(function(data) {
            // console.log(data);
            if(data.success === true) {

              self.merchantSelected(data.item);
              self.getPartnerLink();
            }
          })
          .catch(function(err) {
            console.log("get link error ");
            // console.log(err);
          })
      }
    },
    getPartnerLink: function() {
      let self = this;

      if(this.$route.params.hasOwnProperty('partnerlink')) {
        getMerchantPermalink(this.$route.params.partnerlink)
          .then(function(data) {
            console.log("get partner link " + self.$route.params.partnerlink )
            console.log(data);
            if(data.success === true) {

              self.$data.partner = data.item;

            }
          })
          .catch(function(err) {
            console.log("get link error ");
            // console.log(err);
          })
      }
    },
    merchantSelected: function(merchant) {
      merchant.categories = [];
      merchant.options = [];
      merchant.priceSchedules = [];
      merchant.discounts = [];
      merchant.priceOptions = [];
      merchant.lastSelections = [];


      // console.log("MERCHANT");
      // console.log(merchant);
      this.$data.images = [];

      // console.log("now check websetting")
      if (merchant.webSetting !== undefined && merchant.webSetting !== null && merchant.webSetting.imageUrls !== undefined && merchant.webSetting.imageUrls.length > 0) {
        this.$data.images = merchant.webSetting.imageUrls.split(',');
      } else if (merchant.imageUrl != null && merchant.imageUrl.length > 0) {


        merchant.imageUrl = merchant.imageUrl.replace(
          new RegExp('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos', 'g'), 'https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/aws');
        this.$data.images = merchant.imageUrl.split(',');
      }

      // if (merchant.webSetting !== undefined && merchant.webSetting !== null && merchant.webSetting.bannerImage !== null && merchant.webSetting.bannerImage.length > 0) {
      //   this.$data.additionalOffSet = screen.width * 0.33 + 10;
      // }
      //
      // // console.log(this.$data.images);
      // this.$data.minOrder = 0;
      // this.$data.delayTime = 0;
      // if (merchant.delayTime != undefined) {
      //   this.$data.delayTime = merchant.delayTime;
      // }
      this.$data.currentMerchantItem = JSON.parse(JSON.stringify(merchant));
      // console.log("MErchant Info");
      // console.log(this.$data.currentMerchantItem);
      EventBus.$emit("setTitle", this.$data.currentMerchantItem.title);

      this.setPageMeta();
      submitLog(this.$data.currentMerchantItem.merchantId, 'OrderPage', this.$data.type)
        .then(function (data) {

        })
        .catch(function (err) {

        })
    },
    setPageMeta: function() {
      // console.log("Set PAge Meta");
      const titleEl = document.querySelector('head title');
      const descEl = document.querySelector('head meta[name="description"]');
      const keywordsEl = document.querySelector('head meta[name="keywords"]');

      let title =this.$data.currentMerchantItem.title;
      let key = this.$data.currentMerchantItem.title;
      let description = "Simple click and collect & Takeaway order for " + this.$data.currentMerchantItem.title;
      if(this.$data.currentMerchantItem.region !== undefined && this.$data.currentMerchantItem.region != null && this.$data.currentMerchantItem.region.length > 0) {
        title += " in " + this.$data.currentMerchantItem.region;
        key += "," + this.$data.currentMerchantItem.region;
        description += " in " + this.$data.currentMerchantItem.region;
      }
      key += ", takeaway";
      if(this.$data.currentMerchantItem.tags !== undefined && this.$data.currentMerchantItem.tags != null && this.$data.currentMerchantItem.tags.length > 0) {
        key += "," + this.$data.currentMerchantItem.tags;
      }
      title += " Takeaway | Menu | Price | Show Me The Menu";
      titleEl.textContent = title;

      // console.log("Set title to " + title);
      // console.log("Set Description to " + description);
      descEl.setAttribute('content', description);
      keywordsEl.setAttribute('content', key);

    },
    moveToTakeaway: function() {
      Router.push('/restaurant/' + this.$data.currentMerchantItem.webSetting.subscription_id + '/takeaway');
    },
    moveToDelivery: function() {
      if(this.$data.destination === null || this.$data.destination === '') {
        this.showDialog("Please enter your room number");
        return;
      }
      Router.push('/restaurant/' + this.$data.currentMerchantItem.webSetting.subscription_id + '/delivery?address=Table ' + this.$data.destination);
    },
    showDialog: function(message, title = '') {
      let params = {
        title:title,
        text:message
      }
      this.$modal.show('dialog', params);
    }
  }
}

</script>
<style>
.info-icon {
  height: 18px;

}
.order-type-select-btn {
  padding: 10px 0 10px 0;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 20px;
  background: white;
  font-weight: bold;
  font-size: 20px;
  box-shadow: 3px 3px 5px rgba(0,0,0,0.4);
}
.input-form-container .row {
  padding-top: 20px;
}

.place-order-restaurant-title-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color:white;
  background-color: rgba(0,0,0,0.2);
}
.place-order-title-container {
  font-weight: 400;
  font-size: 40px;
  line-height: 48px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.3em;


  color: #FFFFFF;
}
.place-subtitle {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.2em;
  margin-right: -0.2em;

  color: #FFFFFF;
}
.order-place-info-container {

}
.order-place-bottom-container {
  width: 100%;
  background-color: white;
  //padding: 10px;
  padding-top: 80px;

}
.order-place-bottom-container a{
  color: black;
}
.slider-indicators {
  display: none;
}
.home-main-order-btn {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.2em;

  color: #000000;
  background: #FFFFFF;
  padding: 18px 25px;
  transition: background-color 0.3s ease-in-out;

  cursor: pointer;

  margin-top: 30px;
  margin-bottom: 50px;
}
.home-main-order-btn:hover {
  background-color: #DBDBDB;
}

.webpage-section-header {
  margin-top: 20px;
  font-weight: bold;
}
.place-restaurant-image {
  background-size: cover;
  background-position: center;
  position: relative;
  width: 100%;

}
.top-nav {
  display: none;
}
.black-btn {
  background: #000;
  color: #fff;
  line-height: 40px;
  border-radius: 5px;
}
.white-gray-btn {
  background: white;
  color: #878787;
  line-height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/CollaboOrder.vue